export default __webpack_public_path__ + "static/media/pirati.b3dced4f.svg";